import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-file-segment-options',
  templateUrl: './file-segment-options.component.html',
  styleUrls: ['./file-segment-options.component.scss'],
  standalone: false
})
export class FileSegmentOptionsComponent implements OnInit {
  @Input() coverColor;
  @Input() docColor;
  @Input() disabled;
  @Input() printingGroup;
  @Input() coverLaminated;
  @Input() index;
  @Output() onChange = new EventEmitter<any>();
  segmentSelected: 'none' | 'coverColor' | 'docColor';

  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.docColor) this.segmentSelected = 'docColor';
    else if (this.coverColor) this.segmentSelected = 'coverColor';
    else this.segmentSelected = 'none';
  }

  ngOnInit() {
  }

  onSegmentChange(event) {
    this.onChange.emit({
      action: 'docOptions',
      value: event.detail.value
    });
  }

  showCoverColorSegment() {
    return this.printingGroup.printSettings.finishing !== 'stapled' && !this.coverLaminated;
  }

  showByNSegment() {
    return undefined;
  }

  getCoverColorTitle() {
    return this.coverLaminated ? 'Blanco <br> y Negro' : 'Portada <br> a Color';
  }


}
